exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dropdown .apollo-header-menu{width:15pc;margin:0;padding:5px 0;box-shadow:rgba(0,0,0,.16) 0 0 10px 0;background-color:#fff;border-radius:2px;position:absolute;top:calc(100% + 4px);right:0;left:auto;float:none;z-index:-1000;display:block;list-style:none;border:none;background-clip:initial;opacity:0;transform-origin:0 0;transform:scaleY(.8);transition:all .2s}.dropdown .apollo-header-menu.visible{opacity:1;transform:scaleY(1);z-index:1000}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader/lib!./src/components/Header/components/HeaderDropDown/style.css
 ** module id = 1636
 ** module chunks = 0
 **/